import { NgModule } from '@angular/core';
import { SharedDependenciesModule } from 'src/app/shared';

import { ViDswFooterComponent } from '../shared/+design-system-web/vi-dsw-footer/vi-dsw-footer.component';
import { BannerDemoComponent } from './banner/banner-demo.component';
import { MaterialButtonDemoComponent } from './material-button-demo/material-button-demo.component';
import { MaterialDatepickerDemoComponent } from './material-datepicker-demo/material-datepicker-demo.component';
import { MaterialDemoRouting } from './material-demo.routing';
import { MaterialInputDemoComponent } from './material-input-demo/material-input-demo.component';
import { MaterialLandingPageComponent } from './material-landing-page/material-landing-page.component';
import { MaterialSelectDemoComponent } from './material-select-demo/material-select-demo.component';
import { MaterialTextareaDemoComponent } from './material-textarea-demo/material-textarea-demo.component';
import { PillDemoComponent } from './pill/pill-demo.component';
import { UnitsDemoComponent } from './units-demo/units-demo.component';

@NgModule({
  imports: [SharedDependenciesModule, MaterialDemoRouting, ViDswFooterComponent],
  declarations: [
    MaterialSelectDemoComponent,
    MaterialInputDemoComponent,
    MaterialTextareaDemoComponent,
    MaterialButtonDemoComponent,
    BannerDemoComponent,
    PillDemoComponent,
    MaterialLandingPageComponent,
    UnitsDemoComponent,
    MaterialDatepickerDemoComponent,
  ],
})
export class MaterialDemoModule {}
